<template>
    <v-container fluid>
        <notification-form
            :notification="model"
            :titlePrefix="$t('forms.title_prefix.add')"
            @saved="saved"
        />
    </v-container>
</template>

<script>
import NotificationForm from './Form'
import Notification from '@/models/Notification'

export default {
    components: { NotificationForm },

    data: () => ({ model: new Notification() }),

    methods: {
        saved() {
            this.$router.go(-1)
        },
    },
}
</script>

<style></style>
